<template>
    <div class="obras">
        <div class="container">
            <h2 class="text-center">Novedades</h2>
            <hr>
            <div class="caja-noticias mb-4">
                    <router-link :to="`/noticia/${noticia.id}`" v-for="(noticia,i) in home" :key="i" class="prev-noticia" >

                        <progressive-background class="obra-img"  :src="`https://espais.com.py${noticia.imagen.data.url}`">
                                        <div slot="content" slot-scope="{ visible }">
                                            <div v-show="visible"></div>
                                        </div>
                        </progressive-background>
                        <div class="noticia-thumb-texto-todo">
                            <div class="titulo-noticia-thumb">
                                <h4>{{noticia.titulo}}</h4>
                            </div>
                           <div class="date-noticia-thumb">{{noticia.fecha}}</div>
                        </div>
                    </router-link>
            </div>
            <div class="row">
                <div class="col">
                    <div class="mx-auto text-center pointer py-3">
                        <div v-if="Anteriores_btn" class="ver-mas" v-on:click="mas()">Anteriores</div>
                    </div>
                </div>
            </div>
     </div>
        <!-- <div class="caja-boton">
              <button class="ver-mas-boton"  v-on:click="mas()">Mas noticias</button>
        </div> -->
     </div>
</template>


<script>
export default {
  data() {
    return {
      metaInfo: {
        title: "Noticias de Espais.com.py"
      },
      home: [],
      new_data: [],
      page: 0,
      Anteriores_btn : true
    };
  },
  methods: {
    loadLogs() {
      this.$http
        .get(
          `https://espais.com.py/admin/api/1.1/tables/noticias/rows?order[sort]=DESC&&offset=${
            this.page
          }&&limit=6`
        )
        .then(function(data) {
          this.home = data.body.data;
        });
    },
    mas() {
      this.page = this.page + 6;
      this.$http
        .get(
          `https://espais.com.py/admin/api/1.1/tables/noticias/rows?order[sort]=DESC&&offset=${
            this.page
          }&&limit=6`
        )
        .then(function(data) {
          this.home.push.apply(this.home,data.body.data);
         if(data.body.data.length < 6){this.Anteriores_btn = false;} 
         
        })
        .catch(function(error) {
          alert(error);
        });
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.loadLogs();
    });
  }
};
</script>

<style>
.pointer{
    cursor: pointer;
}
.caja-boton {
  display: flex;
  justify-content: center;
}
.caja-boton button {
  background-color: none;
  border: 0px;
  color: #02666c !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Noticias.vue